<template>
  <div id='register_box'>
    <div id='header' @click='$router.go(-1)'>
      <img id='back' src='../../assets/login/return_btn_icon.png'/>
      <span id='back_text'>返回</span>
    </div>
    <div id='body'>
      <div id='mobile_div'>
        <img src='../../assets/login/user_login_name_icon.png'/>
        <input v-model='mobile' id='register_mobile' class='text-input' type='text' placeholder="请输入手机号">
      </div>
      <div id='pass_code_div'>
        <input v-model='auth_code'  id='mobile_code' class='text-input' type='text' placeholder="验证码">
        <button @click.stop.prevent='getAuthCode' id='get_code_btn'>{{authCodeBtnText}}</button>
      </div>
      <div id='passwd_div'>
        <input v-model='passwd1' class='text-input password' type='password' placeholder="请输入6-20位密码">
      </div>
      <div id='again_passwd_div'>
        <input v-model='passwd2' class='text-input password' type='password' placeholder="请确认密码">
      </div>
      <div id='read_contract'>
        <input type='checkbox' id='contract_checkbox' v-model='isAgree'>
        <label for='contract_checkbox' id='agree_contract'>阅读并同意</label>
        <a href='https://www.baidu.com' id='contract_content'>《协议》</a>
      </div>
    </div>
    <div id='footer'>
      <button @click='register' id='regiter_btn'>立即注册</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {
      mobile: '',
      auth_code: '',
      passwd1: '',
      passwd2: '',
      isAgree: false,
      authCodeBtnText: '获取验证码',
      totalTime: 5,
      countDownClock: null
    }
  },
  methods: {
    register () {
      console.log(this.isAgree)
      if (!this.mobile) {
        return this.$message.warning('请输入手机号')
      }
      if (!this.auth_code) {
        return this.$message.warning('请输入验证码')
      }
      if (!this.passwd1) {
        return this.$message.warning('请输入密码')
      }
      if (!this.passwd2) {
        return this.$message.warning('请输入确认密码')
      }
      if (this.passwd1 !== this.passwd2) {
        return this.$message.warning('两次输入的密码不相同')
      }
      if (!this.isAgree) {
        return this.$message.warning('请阅读并同意相关协议')
      }

      var data = {area_code: '86', mobile: this.mobile, auth_code: this.auth_code, passwd: this.passwd1, name: ''}
      this.$api.login.userRegister(data).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('注册成功')
        this.$router.push('/login')
      }).catch(err => {
        this.$message.error(err)
      })
    },
    getAuthCode () {
      if (this.countDownClock) {
        return
      }
      if (!this.mobile) {
        return this.$message.warning('请输入手机号')
      }
      var params = {area_code: '86', mobile: this.mobile}
      this.$api.login.getRegisterAuthCode(params).then(res => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.countDown(60)

        this.$message.success('获取成功')
      }).catch(err => {
        this.$message.error(err)
      })
    },
    countDown (wait) {
      if (!wait) {
        clearTimeout(this.countDownClock)
        this.countDownClock = null
        this.authCodeBtnText = '获取验证码'
      } else {
        this.authCodeBtnText = '获取验证码(' + wait + 's)'
        wait--
        this.countDownClock = setTimeout(() => {
          this.countDown(wait)
        }, 1000)
      }
    }
  }
}

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.text-input::-webkit-input-placeholder {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.text-input::-moz-placeholder {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.text-input::-ms-input-placeholder {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #c1c1c1;
  letter-spacing: 0;
}
.text-input {
  margin: 5px;
  font-size: 14px;
  height: 20px;
  border: none;
  outline: none;
  font-family: 'PingFangSC-Regular';
}
#register_box {
  width: 387px;
  height: 526px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -263px 0 0 -193px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 30px #aca9a9;
}
#header {
  display: inline-block;
  margin: 15px;
  margin-left: 8%;
  cursor: pointer;
}
#back {
  vertical-align: middle;
}
#back_text {
  font-family: 'PingFangSC-Regular';
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
}
#body {
  display: inline-block;
  margin: 10% 15%;
}
#mobile_div {
  border-bottom: 1px solid #DADADA;
}
#pass_code_div {
  margin-top: 25px;
  border-bottom: 1px solid #DADADA;
}
#passwd_div {
  margin-top: 25px;
  border-bottom: 1px solid #DADADA;
}
#again_passwd_div {
  margin-top: 25px;
  border-bottom: 1px solid #DADADA;
}
#read_contract {
  float: left;
  margin-top: 25px;
}
#footer {
  margin-top: 25px;
  text-align: center;
}
#contract_checkbox {
  display: none;
  float: left;
}
#contract_checkbox:checked+label::before {
  vertical-align: middle;
  padding-right: 5px;
  content: url('../../assets/login/checkbox_select.png');
}
#contract_checkbox:not(:checked)+label::before {
  vertical-align: middle;
  padding-right: 5px;
  content: url('../../assets/login/checkbox_bg.png')
}
#agree_contract {
  font-family: 'PingFangSC-Regular';
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
}
#contract_content {
  font-family: 'PingFangSC-Regular';
  font-size: 12px;
  color: #5DC0BA;
  letter-spacing: 0;
  line-height: 17px;
  text-decoration: none;
}
.password {
  width: 90%;
}
#register_mobile {
  border: none;
  width: 85%;
}
#mobile_code {
  border: none;
  width: 50%;
}
#get_code_btn {
  width: 100px;
  height: 24px;
  border: none;
  background-color: #f1f1f1;
  border-radius: 2px;
  font-family: 'PingFangSC-Regular';
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  cursor: pointer;
  outline: none;
}
#regiter_btn {
  width: 200px;
  height: 35px;
  background: #5DC0BA;
  border-radius: 20px;
  border: none;
  font-size: 15px;
  color: #ffffff;
  cursor: pointer;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/page/login/Register.vue